import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ListarMembrosFilters, UpdatePapelDto } from '@/types/escritorio/escritorioTypes';

import { escritorioMembrosService } from './services';

export const listarMembros = createAsyncThunk(
  'escritorio/membros/listar',
  async (
    { escritorioId, filters }: { escritorioId: string; filters?: ListarMembrosFilters },
    { rejectWithValue },
  ) => {
    try {
      return await escritorioMembrosService.listar(escritorioId, filters);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const updatePapelMembro = createAsyncThunk(
  'escritorio/membros/updatePapel',
  async (
    {
      escritorioId,
      membroId,
      data,
    }: {
      escritorioId: string;
      membroId: string;
      data: UpdatePapelDto;
    },
    { rejectWithValue },
  ) => {
    try {
      return await escritorioMembrosService.updatePapel(escritorioId, membroId, data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const toggleStatusMembro = createAsyncThunk(
  'escritorio/membros/toggleStatus',
  async (
    { escritorioId, membroId }: { escritorioId: string; membroId: string },
    { rejectWithValue },
  ) => {
    try {
      return await escritorioMembrosService.toggleStatus(escritorioId, membroId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const removerMembro = createAsyncThunk(
  'escritorio/membros/remover',
  async (
    { escritorioId, membroId }: { escritorioId: string; membroId: string },
    { rejectWithValue },
  ) => {
    try {
      await escritorioMembrosService.remover(escritorioId, membroId);
      return membroId;
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
